import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { BoxQuestionnaireStatus } from '../enums';
import { BoxQuestionnaireStatusProviderService } from '../providers';

@Pipe({
  name: 'boxQuestionnaireStatus',
})
export class BoxQuestionnaireStatusPipe implements PipeTransform {
  private readonly provider = inject(BoxQuestionnaireStatusProviderService);

  public transform(status: BoxQuestionnaireStatus): Observable<string> {
    return this.provider.labelFor(status);
  }
}
